// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10zMb","clinicsSelect":"styles_clinicsSelect__2UVto"};